import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/file/v1`;

export function exportDatabseFile() {
    const result =  axios({
        method: "POST",
        headers: getHeaders(),
        url: `${url}/db_backup`
    });
    return new Promise((resolve, reject) => {
        result
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
}